import { Button, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import DataTable from "../../components/features/Datatable";
import Filter from "./Filter";
import { getQRCodeSubjectList, subjectQRGeneration, generateQRCode } from "../../slices/QRCode";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { useEffect } from "react";
import { hasAuthority } from "../../../utils/authorities";
import { setSlugs } from "../../slices/help";
import ChatModule from "../Chat";
import { addPatientList, addPhaseList } from "../../slices/chat";
import {capitalizeWords} from "../../../utils/utils"
const QRCodeGeneration = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const LoginData = useSelector((state) => state.loginData);
    const bmr_permissions = LoginData?.bmr_permissions || [];
    const qrSubjectList = useSelector(subjectQRGeneration);

    const filterConfig = {
        type: {
            label: "Type",
            enum: {
                1: 'Trial',
                2: 'PMS',
                3: 'Commercial',
            },
        },
        qr_status: {
            label: "QR Status",
            enum: {
                0: 'Pending',
                1: 'QR Code Generated',
            },
        },
        apheresis_date: {
            label: "Apheresis Date",
        },
    }

    const updateFilter = (filter) => {
        fetchUsers(filter);
    }

    const fetchUsers = async (filter) => {
        dispatch(getQRCodeSubjectList(filter));
    }

    const generateQRForPatient = async (data) => {
        let payload = {}
        payload.feasibility_assessments_id = data.feasibility_id
        payload.subject_id = data.subject_id
        const generateQrResponse = await dispatch(generateQRCode(payload)).unwrap()
        if (generateQrResponse.success) {
            let qrGenerationId = generateQrResponse.data.qr_generation_id
            navigate(`/bmr/lsm/details/${qrGenerationId}`,{
                state: [
                { name: "Subjects", path: location.pathname },
                {
                name: data?.subject_name,
                path: `/bmr/lsm/details/${qrGenerationId}`,
                },
                ],
           });
        }
    }

    const getFormattedDate = (date) => {
        return moment(date).format("DD/MM/YYYY");
    }

    const columns = [
        { id: "patient_id", name: "Subject/Patient ID", selector: row => row.subject_patient_id ? row.subject_patient_id : "N/A", sortable: true },
        { id: "subject_name", name: "Subject Name", selector: row => row.subject_name ? capitalizeWords(row.subject_name) : "N/A", sortable: true },
        { id: "product", name: "Product/Phase", selector: row => row.product_name && row.phase_name ? `${capitalizeWords(row.product_name)}/${capitalizeWords(row.phase_name)}` : "N/A", sortable: true },
        { id: "phase_type", name: "Type", selector: row => row.phase_type ? row.phase_type : "N/A", sortable: true },
        { id: "hospital_name", name: "Hospital", selector: row => row.hospital_name ? row.hospital_name : "N/A", sortable: true },
        { id: "scheduled_apheresis_date", name: "Apheresis Date", selector: row => row.scheduled_apheresis_date ? getFormattedDate(row.scheduled_apheresis_date) : "N/A", sortable: true },
        {
            id: "qr_status", name: "Status", selector: row => row.qr_status ?
                row.qr_status == "QR Code Generated" ? <p className="text-[#00B278] font-roboto font-normal text-[14px] leading-[100%] tracking-[0%]">{row?.qr_status}</p> :
                    <p className="font-roboto font-normal text-[14px] leading-[100%] tracking-[0] text-[#FF2023]">{row?.qr_status}</p> :
                "N/A", sortable: true
        },
        {
            name: "Action",
            selector: row =>
                row.qr_status && row.qr_status == "QR Code Generated" ?
                    <Button
                        onClick={() => navigate(`/bmr/lsm/details/${row.qr_code_generated_id}`,
                            {
                            state: [
                            { name: "QR Code Generation", path: location.pathname },
                            {
                            name: "Details",
                            path: `/bmr/lsm/details/${row.qr_code_generated_id}`,
                            },
                            ],
           }
                        )}
                        key={row.id}
                        size="small"
                        className="!w-[150px]"
                    >
                        View Details
                    </Button> :
                    <Button
                        onClick={() => generateQRForPatient(row)}
                        key={row.id}
                        size="small"
                        className="!w-[150px]"
                    >
                        Generate LSM QR
                    </Button>
        },
    ];

    useEffect(() => {
        if (hasAuthority(["generate-lsm-qr"], bmr_permissions)) {
            dispatch(setSlugs(["generate-lsm-qr"]));
        }
        return () => {

            dispatch(setSlugs([" "]));

        };
    }, []);

    ////////// phase and pantient List for chat bot ///////////

    useEffect(() => {
            const phaseList = qrSubjectList?.items?.map(op => { return { value: op?.phase_id, label: `${op?.phase_name} (${op?.product_name})`, patient_id: op?.subject_id } })
            const patientList = qrSubjectList?.items?.map(op => { return { value: op?.subject_id, label: `${op?.subject_name}`, phase_id: op?.phase_id } })
            dispatch(addPatientList(patientList))
            dispatch(addPhaseList(phaseList))
    }, [qrSubjectList])

    ////////////////////////////////////////////////////////////

    return (
        <Grid container className="mt-2 ml-0 mr-3 mainDiv" rowSpacing={4.5} columnSpacing={2.75} >
            <Grid item xs={12} sx={{ mt: -2.25 }}>
                {/* {hasAuthority(['subjects-listing'], bmr_permissions) && */}
                <DataTable
                    columns={columns}
                    data={qrSubjectList ?? []}
                    title="Subject"
                    FilterComponent={Filter}
                    onServerSideChange={updateFilter}
                    remote={true}
                    filterConfig={filterConfig}
                />
                {/* } */}
                <ChatModule />
            </Grid>
        </Grid>
    );
};

export default QRCodeGeneration;
